import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { LINEAR_MODEL_FORM } from 'store/form';
import { linearModel } from 'mobx-store';

import { getFilteredParametersValuesNotEmptyLength } from 'store/dataset';

import {
  getPrimaryParameter,
  getSecondaryParameter,
  isPrimaryParameterSelected
} from 'store/form/linearModel/selectors';

import {
  setSecondaryParameter,
  setPrimaryAndResetSecondary
} from 'store/scenes/linearModel/actions';

import SettingsFormComponent from './Component';

class SettingsFormContainer extends React.PureComponent {
  static propTypes = {
    form: PropTypes.string.isRequired,
    datasetLength: PropTypes.number.isRequired,

    primaryParameter: PropTypes.string.isRequired,
    secondaryParameterVisible: PropTypes.bool.isRequired,

    setSecondaryParameter: PropTypes.func.isRequired,
    setPrimaryAndResetSecondary: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    this.handlePrimaryParameterChange = this.props.setPrimaryAndResetSecondary;
    this.handleSecondaryParameterChange = this.props.setSecondaryParameter;
  }

  componentDidMount () {
    linearModel.setVisibleSlider(false);
  }

  get showEmptyDatasetWarning () {
    return this.props.datasetLength <= 1 && !!this.props.primaryParameter;
  }

  render () {
    return (
      <SettingsFormComponent
        form={this.props.form}
        primaryParameter={this.props.primaryParameter}
        showEmptyDatasetWarning={this.showEmptyDatasetWarning}
        secondaryParameterVisible={this.props.secondaryParameterVisible}

        onPrimaryParameterChange={this.handlePrimaryParameterChange}
        onSecondaryParameterChange={this.handleSecondaryParameterChange}
      />
    );
  }
}

const mapStateToProps = state => {
  const primaryParameter = getPrimaryParameter(state) || '';
  const secondaryParameter = getSecondaryParameter(state) || '';

  return ({
    datasetLength: getFilteredParametersValuesNotEmptyLength(state, primaryParameter, secondaryParameter),
    primaryParameter,
    secondaryParameter,
    secondaryParameterVisible: isPrimaryParameterSelected(state)
  });
};

const mapDispatchToProps = {
  setSecondaryParameter,
  setPrimaryAndResetSecondary
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({ form: LINEAR_MODEL_FORM, destroyOnUnmount: false })(
    SettingsFormContainer
  )
);
